<template>
  <b-autocomplete
    :inputStyle="{ 'flex-grow': 1, width: '100%' }"
    :items="searchItems"
    placeholder="Починайте вводити ім’я або групу"
    class="block mb-2"
    item-title="name"
    item-value="id"
    style="width: 25rem; max-width: 100%"
    @focus="getSearchItems($event)">
    <template #item="{ item }">
      <item :entity="item.raw" @click="createAssignment(item.raw)"></item>
    </template>
  </b-autocomplete>
</template>

<script lang="ts">
import Item from './EntityItem.vue'
import { ref } from 'vue'
import { getDirectory } from '@/directory'
import { useAcknowledgment } from './index'

export default {
  components: { Item },
  setup() {
    const { createAssignment, findAssignmentByEntity } = useAcknowledgment()
    const searchItems = ref<any[]>([])

    const getSearchItems = (event: any) => {
      searchItems.value = []
      const entityList = getDirectory('entityList').filter(e => {
        return !findAssignmentByEntity(e.entityTypeId, e.entityId)
      })

      const searchTerm = event && typeof event === 'string' ? event : ''

      if (!searchTerm.trim().length) {
        searchItems.value = [...entityList]
      } else {
        searchItems.value = Array.from(
          entityList.filter(e => {
            return e.name.toLowerCase().includes(searchTerm.toLowerCase())
          })
        )
      }
    }

    return {
      getSearchItems,
      searchItems,
      createAssignment,
    }
  },
}
</script>

<style lang="scss" scoped></style>
